export default __webpack_public_path__ + "static/media/c001-Picture1.1bc9836b.jpg";